/**
 * Nhóm social/chat official gắn team (đồng bộ từ AzaSystem).
 *
 * @param {{ team_id?: *, is_official_team_group?: boolean }|null|undefined} entity
 * @returns {boolean}
 */
export function isOfficialTeamGroup(entity) {
  if (!entity) {
    return false;
  }
  if (entity.is_official_team_group === true) {
    return true;
  }
  const tid = entity.team_id;
  if (tid == null || tid === '') {
    return false;
  }
  const n = Number(tid);
  return Number.isFinite(n) && n > 0;
}

export const OFFICIAL_TEAM_VERIFIED_CHAT_TITLE =
  'Nhóm chat chính thức theo đội (đã liên kết hệ thống)';

export const OFFICIAL_TEAM_VERIFIED_SOCIAL_TITLE =
  'Nhóm social chính thức theo đội (đã liên kết hệ thống)';
